/**
 * Product Video Autoplay — Dawn Theme (final clean version)
 *
 * PRODUCT PAGE: IntersectionObserver injects video from <template> on scroll.
 * COLLECTION CARDS: media_tag renders <video> in HTML already.
 *   We just force .play() since autoplay attribute alone isn't always enough.
 */
(function () {
  'use strict';

  /* ── PRODUCT PAGE ─────────────────────────────────────────────────────── */

  var productObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activateDeferred(entry.target);
      else pauseDeferred(entry.target);
    });
  }, { threshold: 0.25 });

  function activateDeferred(deferred) {
    if (!deferred.hasAttribute('loaded')) injectVideo(deferred);
    else resumeMedia(deferred);
  }

  function injectVideo(deferred) {
    var tmpl = deferred.querySelector('template');
    if (!tmpl) return;
    var first = tmpl.content.firstElementChild;
    if (!first) return;
    var clone = first.cloneNode(true);

    if (clone.tagName === 'VIDEO') {
      clone.muted = true;
      clone.autoplay = true;
      clone.setAttribute('playsinline', '');
      clone.removeAttribute('controls');
      clone.loop = true;
      clone.preload = 'metadata';
    }
    if (clone.tagName === 'IFRAME') {
      clone.src = patchIframeSrc(clone.src || clone.getAttribute('data-src') || '');
    }

    deferred.setAttribute('loaded', '');
    var poster = deferred.querySelector('.deferred-media__poster');
    if (poster) poster.hidden = true;
    deferred.appendChild(clone);
    if (clone.tagName === 'VIDEO') clone.play().catch(function () {});
  }

  function resumeMedia(deferred) {
    var v = deferred.querySelector('video');
    if (v && v.paused) v.play().catch(function () {});
    var yt = deferred.querySelector('.js-youtube');
    if (yt) postMsg(yt, '{"event":"command","func":"playVideo","args":""}');
    var vim = deferred.querySelector('.js-vimeo');
    if (vim) postMsg(vim, '{"method":"play"}');
  }

  function pauseDeferred(deferred) {
    if (!deferred.hasAttribute('loaded')) return;
    var v = deferred.querySelector('video');
    if (v) v.pause();
    var yt = deferred.querySelector('.js-youtube');
    if (yt) postMsg(yt, '{"event":"command","func":"pauseVideo","args":""}');
    var vim = deferred.querySelector('.js-vimeo');
    if (vim) postMsg(vim, '{"method":"pause"}');
  }

  function postMsg(iframe, str) {
    try { iframe.contentWindow.postMessage(str, '*'); } catch (e) {}
  }

  function patchIframeSrc(src) {
    if (!src) return src;
    try {
      var url = new URL(src, window.location.href);
      if (url.hostname.indexOf('youtube') > -1) {
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('enablejsapi', '1');
      }
      if (url.hostname.indexOf('vimeo') > -1) {
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('muted', '1');
        url.searchParams.set('background', '1');
      }
      return url.toString();
    } catch (e) { return src; }
  }

  function initProductPage() {
    document.querySelectorAll('.product__media-list deferred-media').forEach(function (deferred) {
      var tmpl = deferred.querySelector('template');
      if (!tmpl) return;
      var first = tmpl.content.firstElementChild;
      if (!first || (first.tagName !== 'VIDEO' && first.tagName !== 'IFRAME')) return;
      var slide = deferred.closest('.product__media-item');
      if (slide) slide.setAttribute('data-has-autoplay-video', '');
      productObserver.observe(deferred);
    });

    var viewer = document.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', function () {
        setTimeout(function () {
          document.querySelectorAll('.product__media-list deferred-media').forEach(function (deferred) {
            var r = deferred.getBoundingClientRect();
            if (r.width > 0 && r.height > 0) activateDeferred(deferred);
          });
        }, 100);
      });
    }
  }

  /* ── COLLECTION CARDS ────────────────────────────────────────────────── */
  /*
   * Liquid's media_tag already rendered <video class="card-autoplay-video">
   * in the HTML. We just need to call .play() because:
   *  1. Some browsers ignore the autoplay attribute without a JS play() call
   *  2. The theme editor preview sandbox blocks attribute-based autoplay
   */

  function initCardVideos() {
    document.querySelectorAll('video.card-autoplay-video').forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.play().catch(function () {});
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */

  function init() {
    initProductPage();
    initCardVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    productObserver.disconnect();
    init();
  });

})();